import React from "react";
import { Link } from "react-router-dom";
import { BarChart3, Receipt, Coins, Boxes } from "lucide-react";
import { Card, SectionTitle, Pill } from "@/components/layout/PageShell";

const QUICK_LINKS = [
  { label: "Daily Sales", path: "/reports/daily-sales", icon: BarChart3, tone: "blue" },
  { label: "POS Bill History", path: "/reports/bill-history", icon: Receipt, tone: "purple" },
  { label: "Cash Collection", path: "/reports/cash-collection", icon: Coins, tone: "green" },
  { label: "Top Items", path: "/reports/top-items", icon: Boxes, tone: "amber" },
  { label: "Order Summary", path: "/reports/order-summary", icon: Receipt, tone: "purple" },
];

export default function ReportCenterHome() {
  return (
    <div data-testid="report-center-home">
      <Card className="p-6 mb-4">
        <h2 className="text-[18px] font-semibold text-slate-900">Select a report</h2>
        <p className="text-[13px] text-slate-500 mt-1 max-w-xl">
          Choose a report from the menu on the left. Filters, print, and live data load in this panel.
        </p>
      </Card>

      <SectionTitle action={<Pill tone="blue">Quick access</Pill>}>Popular reports</SectionTitle>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {QUICK_LINKS.map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex items-center gap-3 p-4 rounded-xl border border-[#E5E7EB] bg-white hover:border-blue-300 hover:shadow-sm transition-all"
            >
              <span className="h-10 w-10 rounded-lg bg-blue-50 text-blue-600 grid place-items-center">
                <Icon size={18} />
              </span>
              <span className="text-[14px] font-semibold text-slate-800">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
